// removed by extract-text-webpack-plugin
module.exports = {"link":"Link__link___2mUeW"};